export const STATUS_ICONS = {
    completed: 'circle-success',
    failure: 'circle-cancel',
    processing: 'tube-spinner',
    new: 'skipper',
    notDone: 'skipper',
    skip: 'skipper',
    initializing: 'tube-spinner',
    queued: 'queue',
    outdated: 'update',
};

/** Status de job/execução alinhado às chaves de STATUS_ICONS / STATUS_LABELS. */
export type PipelineExecutionStatus = keyof typeof STATUS_ICONS;

export const STATUS_LABELS = {
    initializing: 'INICIANDO',
    completed: 'SUCESSO',
    failure: 'FALHA',
    processing: 'PROCESSANDO',
    new: 'NÃO EXECUTADO',
    notDone: 'NÂO EXECUTADO',
    skip: 'IGNORADO',
    queued: 'EM ESPERA',
    outdated: 'DESATUALIZADO',
};

export const STATUS_COLORS = {
    success: '#00812b',
    completed: '#00812b',
    failure: '#ff2e1f',
    processing: '#4c5059',
    new: '#4c5059',
    notDone: '#4c5059',
    skip: '#4c5059',
    initializing: '#4c5059',
    queued: '#4c5059',
    outdated: '#ed6c02',
};

export const STAGE_COLORS = {
    Bronze: '#CD7F32',
    Prata: '#C0C0C0',
    Ouro: '#FFD700',
};



export const LAYER_NAMES = {
    bronze: 'Bronze',
    silver: 'Prata',
    gold: 'Ouro'
};